module.exports = __webpack_public_path__ + "img/arrow-left.2bdc54a4.svg";